import { Form, Input } from 'antd';
import { libraryService } from 'content/library/service';
import { LibraryInterface, OdkMetaInterface } from 'content/library/types/contentType';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Service.css';

export const ServiceDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [library, setLibrary] = useState<LibraryInterface | undefined>();
  const [odkMeta, setOdkMeta] = useState<OdkMetaInterface | undefined>();
  useEffect(() => {
    libraryService.fetchLibrary(Number(id)).then(library => {
      setLibrary(library);
      setOdkMeta(library.odk_meta);
      form.setFieldsValue(library);
    });
  }, [form, id]);

  return (
    <div>
      <div className="content-details-page" style={{ display: 'flex' }}>
        <div className="content-details-edit">
          <h1>{library && library.title}</h1>
          <Form form={form} layout="vertical" className="content-details-form">
            {odkMeta ? (
              <>
                <h2>distributed service: {odkMeta.service_name} </h2>
                <Form.Item label="service name" name={['odk_meta', 'service_name']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="episode id" name={['odk_meta', 'episode_id']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="uuid" name={['odk_meta', 'uuid']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="slug" name={['odk_meta', 'slug']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="episode kind" name={['odk_meta', 'episode_kind']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="ingest source" name={['odk_meta', 'ingest_source']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="program id" name={['odk_meta', 'program_id']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="is kocowa" name={['odk_meta', 'is_kocowa']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="on air date" name={['odk_meta', 'on_air_date']}>
                  <Input readOnly />
                </Form.Item>
                <Form.Item
                  label="episode publish start"
                  name={['odk_meta', 'episode_publish_start']}
                >
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="episode publish end" name={['odk_meta', 'episode_publish_end']}>
                  <Input readOnly />
                </Form.Item>
              </>
            ) : null}
            <Form.Item label="odx_legacy_id" name={'odx_legacy_id'}>
              <Input readOnly />
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;
